import React from 'react';
import AboutRoom from '../../AboutRoom/AboutRoom';
import MetersTable from '../../../components/tables/MetersTable/MetersTable';
import HistoryRoom from '../../HistoryRoom/HistoryRoom';

export const tabs = [
  {
    tab: 'Информация',
    key: 'about',
    index: 0,
    renderContent: () => <AboutRoom />,
  },
  {
    tab: 'Счетчики',
    key: 'meters',
    index: 1,
    renderContent: () => <MetersTable lightTheme={false} />,
  },
  // {
  //   tab: 'История',
  //   key: 'history',
  //   index: 2,
  //   renderContent: () => <HistoryRoom />,
  // },
];
